// import logoImage from "../../assets/images/logo2.png";

import IMAGES from "../constant/images";

const Logo = () => {
    return (
        <div className="h-10">
            <img
                src={IMAGES.logoImage}
                alt="logo"
                className="h-full object-contain"
            />
        </div>
    );
};

export default Logo;
